/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { ClosedEnum } from "../../types/enums.js";

/**
 * Possible states an account verification can be in.
 *
 * @deprecated enum: This will be removed in a future release, please migrate away from it as soon as possible.
 */
export const VerificationStatus = {
  Unverified: "unverified",
  Pending: "pending",
  Verified: "verified",
  Errored: "errored",
} as const;
/**
 * Possible states an account verification can be in.
 *
 * @deprecated enum: This will be removed in a future release, please migrate away from it as soon as possible.
 */
export type VerificationStatus = ClosedEnum<typeof VerificationStatus>;

/** @internal */
export const VerificationStatus$inboundSchema: z.ZodNativeEnum<
  typeof VerificationStatus
> = z.nativeEnum(VerificationStatus);
/** @internal */
export const VerificationStatus$outboundSchema: z.ZodNativeEnum<
  typeof VerificationStatus
> = VerificationStatus$inboundSchema;
